import { useState } from 'react';
import { Eye, EyeOff, AlertCircle } from 'lucide-react';

const LoginForm = ({ onLogin, error }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!username || !password) return;

    setLoading(true);
    try {
      await onLogin({ username, password });
    } finally {
      setLoading(false);
    }
  };

  const disabled = loading || !username || !password;

  return (
    <form onSubmit={handleLogin} className="space-y-5">
      {error && (
        <div className="flex items-start gap-2 rounded-xl bg-[#FEF2F2] p-3 text-[13px] text-danger">
          <AlertCircle size={16} className="mt-0.5 flex-none" />
          <p>{error}</p>
        </div>
      )}

      <div>
        <label htmlFor="username" className="label-field">Username</label>
        <input
          id="username"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Masukkan username anda"
          className="input-field"
          autoCapitalize="none"
          autoCorrect="off"
        />
      </div>

      <div>
        <label htmlFor="password" className="label-field">Kata Sandi</label>
        <div className="relative">
          <input
            id="password"
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Masukkan kata sandi"
            className="input-field pr-12"
          />
          <button
            type="button"
            onClick={() => setShowPassword((s) => !s)}
            aria-label={showPassword ? 'Sembunyikan kata sandi' : 'Tampilkan kata sandi'}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-ink-400 hover:text-ink-700"
          >
            {showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
          </button>
        </div>
      </div>

      <button
        type="submit"
        disabled={disabled}
        className={`w-full rounded-full px-5 py-3.5 font-semibold text-white transition ${
          disabled ? 'cursor-not-allowed bg-brand-200' : 'bg-brand-700 hover:bg-brand-800'
        }`}
      >
        {loading ? 'Memproses...' : 'Masuk'}
      </button>

      <div className="rounded-2xl bg-[#FFF7E6] p-4">
        <div className="flex items-start gap-2.5">
          <AlertCircle size={18} className="mt-0.5 flex-none text-warning" />
          <div className="text-[13px] leading-relaxed text-[#92600A]">
            <p className="font-bold text-ink-900">Belum punya akun?</p>
            <p className="mt-1">
              Username dan kata sandi diberikan oleh pihak sekolah. Hubungi admin jika kamu belum menerimanya.
            </p>
            <a
              href="https://wa.me/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-block font-bold text-warning underline"
            >
              Hubungi admin sekolah
            </a>
          </div>
        </div>
      </div>
    </form>
  );
};

export default LoginForm;
